import { omit } from "lodash";

export const MarkDownFieldPlaceHolder = "${finding.id} ${finding.title}";

export const variableRegex = /\${\S*}/gm;

export const templateFieldsDescription = {
  "finding.id": "Finding ID",
  "finding.title": "Summary",
  "finding.status": "Status",
  "finding.severity.value": "Severity",
  "finding.toolSeverity": "Tool Severity",
  "finding.category": "Category",
  "finding.findingCategory": "Tool Finding Category",
  "finding.impact": "Impact",
  "finding.mitigation": "Mitigation",
  "finding.description": "Description",
  "finding.stepsToReproduce": "Steps To Reproduce",
  "finding.evidence": "Evidence",
  "finding.sourceCodeDetails.filePath": "Source File Path",
  "finding.sourceCodeDetails.fileName": "Source File Name",
  "finding.sourceCodeDetails.lineNumber": "Source File Line Number",
  "finding.toolName": "Source",
  "finding.scanType": "Scan Type",
  "finding.product.name": "Product",
  "finding.subProduct.name": "Sub-Product",
  "finding.envName": "Environment",
  "finding.securityOwner.name": "Security Owner",
  "finding.owner.name": "Owner",
  "finding.developer": "Developer",
  "finding.remediationDueDate": "Remediation Due Date",
  "finding.resolutionDueDate": "Resolution Due Date",
  "finding.source.ref": "Tool Finding URL",
  "finding.additionalDetails.repositoryName": "Repository Name",
  "finding.additionalDetails.repositoryUrl": "Repository URL",
  "finding.cves": "CVE",
  "finding.cwes": "CWE",
  "finding.tags": "Tags",
  "finding.policy": "Compliance",
  "finding.imageName": "Image Name",
  "finding.imageTag": "Image Tag",
  "finding.componentName": "Component Name",
  "finding.componentVersion": "Component Version",
  "finding.hostName": "Device",
  "finding.toolTitle": "Tool Title",
  "finding.toolId": "Tool Finding ID",
  "finding.impactScore": "Impact Score",
  "finding.findingScore": "Finding Score",
  "finding.aatiScore": "AATI Score",
  "finding.cvssVector": "CVSS Vector",
  "finding.cvssBaseScore": "CVSS Base Score",
  "finding.exploitabilityScore": "Exploitability Score",
  "finding.toolDescription": "Tool Description",
  "finding.fileName": "File Name",
  "finding.tag.<key>": "Tag Name",
  "finding.armorcodeurl": "Link To ArmorCode Finding",
  "finding.grouped.hostnames": "Grouped Finding Hostnames",
  "finding.riskRating": "Risk Rating",
  "finding.customField.<labelName>": "Finding Custom Field Label Name",
  "finding.cves.nvdurl": "CVE NVD URL",
  "finding.riskScore": "Finding Risk Score",
  "finding.ipAddress": "IP Address",
  "finding.remediationAction": "Remediation Action",
  "finding.remediationGroup": "Remediation Group",
  "finding.triageDueDate": "Triage Due Date",
  "finding.team": "Team",
};

export const templateTitleFieldDescription = {
  "finding.id": "Finding ID",
  "finding.title": "Summary",
  "finding.status": "Status",
  "finding.severity.value": "Severity",
  "finding.toolSeverity": "Tool Severity",
  "finding.category": "Category",
  "finding.findingCategory": "Tool Finding Category",
  "finding.impact": "Impact",
  "finding.mitigation": "Mitigation",
  "finding.description": "Description",
  "finding.stepsToReproduce": "Steps To Reproduce",
  "finding.evidence": "Evidence",
  "finding.sourceCodeDetails.filePath": "Source File Path",
  "finding.sourceCodeDetails.fileName": "Source File Name",
  "finding.sourceCodeDetails.lineNumber": "Source File Line Number",
  "finding.toolName": "Source",
  "finding.scanType": "Scan Type",
  "finding.product.name": "Product",
  "finding.subProduct.name": "Sub-Product",
  "finding.envName": "Environment",
  "finding.securityOwner.name": "Security Owner",
  "finding.owner.name": "Owner",
  "finding.developer": "Developer",
  "finding.remediationDueDate": "Remediation Due Date",
  "finding.resolutionDueDate": "Resolution Due Date",
  "finding.source.ref": "Tool Finding URL",
  "finding.additionalDetails.repositoryName": "Repository Name",
  "finding.additionalDetails.repositoryUrl": "Repository URL",
  "finding.cves": "CVE",
  "finding.cwes": "CWE",
  "finding.tags": "Tags",
  "finding.policy": "Compliance",
  "finding.imageName": "Image Name",
  "finding.imageTag": "Image Tag",
  "finding.componentName": "Component Name",
  "finding.componentVersion": "Component Version",
  "finding.hostName": "Device",
  "finding.toolTitle": "Tool Title",
  "finding.toolId": "Tool Finding ID",
  "finding.impactScore": "Impact Score",
  "finding.findingScore": "Finding Score",
  "finding.aatiScore": "AATI Score",
  "finding.cvssVector": "CVSS Vector",
  "finding.cvssBaseScore": "CVSS Base Score",
  "finding.exploitabilityScore": "Exploitability Score",
  "finding.toolDescription": "Tool Description",
  "finding.fileName": "File Name",
  "finding.tag.<key>": "Tag Name",
  "finding.riskRating": "Risk Rating",
  "finding.customField.<labelName>": "Finding Custom Field Label Name",
  "finding.cves.nvdurl": "CVE NVD URL",
  "finding.riskScore": "Finding Risk Score",
  "finding.ipAddress": "IP Address",
  "finding.triageDueDate": "Triage Due Date",
  "finding.team": "Team",
  runbookname: "Runbook Name",
};

export const templateDetailsFieldDescription = {
  "finding.id": "Finding ID",
  "finding.title": "Summary",
  "finding.status": "Status",
  "finding.severity.value": "Severity",
  "finding.toolSeverity": "Tool Severity",
  "finding.category": "Category",
  "finding.findingCategory": "Tool Finding Category",
  "finding.impact": "Impact",
  "finding.mitigation": "Mitigation",
  "finding.description": "Description",
  "finding.stepsToReproduce": "Steps To Reproduce",
  "finding.evidence": "Evidence",
  "finding.sourceCodeDetails.filePath": "Source File Path",
  "finding.sourceCodeDetails.fileName": "Source File Name",
  "finding.sourceCodeDetails.lineNumber": "Source File Line Number",
  "finding.toolName": "Source",
  "finding.scanType": "Scan Type",
  "finding.product.name": "Product",
  "finding.subProduct.name": "Sub-Product",
  "finding.envName": "Environment",
  "finding.securityOwner.name": "Security Owner",
  "finding.owner.name": "Owner",
  "finding.developer": "Developer",
  "finding.remediationDueDate": "Remediation Due Date",
  "finding.resolutionDueDate": "Resolution Due Date",
  "finding.source.ref": "Tool Finding URL",
  "finding.additionalDetails.repositoryName": "Repository Name",
  "finding.additionalDetails.repositoryUrl": "Repository URL",
  "finding.cves": "CVE",
  "finding.cwes": "CWE",
  "finding.tags": "Tags",
  "finding.policy": "Compliance",
  "finding.imageName": "Image Name",
  "finding.imageTag": "Image Tag",
  "finding.componentName": "Component Name",
  "finding.componentVersion": "Component Version",
  "finding.hostName": "Device",
  "finding.toolTitle": "Tool Title",
  "finding.toolId": "Tool Finding ID",
  "finding.impactScore": "Impact Score",
  "finding.findingScore": "Finding Score",
  "finding.aatiScore": "AATI Score",
  "finding.cvssVector": "CVSS Vector",
  "finding.cvssBaseScore": "CVSS Base Score",
  "finding.exploitabilityScore": "Exploitability Score",
  "finding.toolDescription": "Tool Description",
  "finding.fileName": "File Name",
  "finding.tag.<key>": "Tag Name",
  "finding.riskRating": "Risk Rating",
  "finding.customField.<labelName>": "Finding Custom Field Label Name",
  "finding.cves.nvdurl": "CVE NVD URL",
  "finding.riskScore": "Finding Risk Score",
  "finding.ipAddress": "IP Address",
  "finding.remediationAction": "Remediation Action",
  "finding.remediationGroup": "Remediation Group",
  "finding.triageDueDate": "Triage Due Date",
  "finding.team": "Team",
  "finding.endPointDetails.uri": "Endpoint URI",
  "finding.ownerEmail": "Owner Email",
  "finding.derivedAttributes.<attributeName>": "Derived Attribute Name",
  runbookname: "Runbook Name",
  "finding.foundOnDate": "Finding Found On Date",
  "finding.exploitAvailable": "Finding Exploit Available",
  "finding.componentFixVersion": "Component Fix Version",
};

export const templateLabelFieldsDescription = {
  "finding.id": "Finding ID",
  "finding.status": "Status",
  "finding.severity.value": "Severity",
  "finding.toolSeverity": "Tool Severity",
  "finding.category": "Category",
  "finding.findingCategory": "Tool Finding Category",
  "finding.toolName": "Source",
  "finding.scanType": "Scan Type",
  "finding.product.name": "Product",
  "finding.subProduct.name": "Sub-Product",
  "finding.envName": "Environment",
  "finding.securityOwner.name": "Security Owner",
  "finding.owner.name": "Owner",
  "finding.developer": "Developer",
  "finding.resolutionDueDate": "Resolution Due Date",
  "finding.remediationDueDate": "Remediation Due Date",
  "finding.additionalDetails.repositoryName": "Repository Name",
  "finding.cves": "CVE",
  "finding.cwes": "CWE",
  "finding.componentName": "Component Name",
  "finding.componentVersion": "Component Version",
  "finding.toolId": "Tool Finding ID",
  "finding.impactScore": "Impact Score",
  "finding.findingScore": "Finding Score",
  "finding.aatiScore": "AATI Score",
  "finding.cvssVector": "CVSS Vector",
  "finding.cvssBaseScore": "CVSS Base Score",
  "finding.exploitabilityScore": "Exploitability Score",
  "finding.tag.<key>": "Tag Name",
  "finding.riskRating": "Risk Rating",
  "finding.customField.<labelName>": "Finding Custom Field Label Name",
  "finding.cves.nvdurl": "CVE NVD URL",
  "finding.riskScore": "Finding Risk Score",
  "finding.ipAddress": "IP Address",
  "finding.triageDueDate": "Triage Due Date",
  "finding.team": "Team",
  "finding.endPointDetails.uri": "Endpoint URI",
};

export const multiTemplateFieldDescription = {
  "finding.hostnames": "Finding Hostnames",
};
export const singleTemplateFieldDescription = {
  "finding.armorcodeurl": "Link To ArmorCode Finding",
};

export const ticketTopBottomFieldSupportedVariables = {
  "finding.count": "Finding Count",
  "finding.cves": "CVE",
  "finding.productName": "Product",
  "finding.subproductName": "Subproduct",
  "findings.grouped.source": "Source",
  "finding.customField.<labelName>": "Finding Custom Field Label Name",
  "finding.cvesCount": "Findings CVES Count",
  "finding.toolDescription": "Finding Tool Description",
  "finding.mitigation": "Findings Mitigation",
  "finding.remediationAction": "Remediation Action",
  "finding.remediationGroup": "Remediation Group",
  "finding.derivedAttributes.<attributeName>": "Derived Attribute Name",
  "finding.componentVersion": "Component Version",
  "finding.componentFixVersion": "Component Fix Version",
  ...singleTemplateFieldDescription,
  ...multiTemplateFieldDescription,
};

export const templateFields = Object.keys(templateFieldsDescription);
export const titleFieldSupportedVariableKeys = Object.keys(
  omit(templateFieldsDescription, [
    "finding.armorcodeurl",
    "finding.remediationAction",
    "finding.remediationGroup",
  ]),
);
export const detailsFieldVariableKeysForValidation = Object.keys(
  templateDetailsFieldDescription,
);
export const ticketTopBottomVariableFieldKeys = Object.keys(
  ticketTopBottomFieldSupportedVariables,
);
